import nxModule from 'nxModule';

nxModule.factory('customReportHistory', (CacheFactory) =>
  CacheFactory.createCache('customReportHistory', {
    storageMode: 'localStorage',
    storagePrefix: 'nx__nonvolatile__',
    capacity: 10
  })
);